<template>
  <div class="license-status">
    <!-- ===== สถานะตรวจสอบจาก IPA ===== -->
    <div v-if="item.pt_licence_file_ipa === 'pass'" class="ipa-badge ipa-pass mb-1">
      <v-icon small color="success">mdi-check-circle</v-icon>
      <span class="ml-1">ผ่านการตรวจสอบ</span>
    </div>

    <div v-if="item.pt_licence_file_ipa === 'dontpass'" class="ipa-badge ipa-fail mb-1">
      <v-icon small color="error">mdi-alert-circle</v-icon>
      <span class="ml-1">{{ item.pt_licence_file_ipacomment }}</span>
    </div>

    <!-- ===== กรณีมีใบประกอบวิชาชีพครู ===== -->
    <template v-if="item.mt_license_status === 'have'">
      <!-- ไม่ได้แนบไฟล์ -->
      <v-btn
        v-if="!hasLicenceFile"
        small
        outlined
        color="error"
        class="license-btn"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-alert</v-icon>
        ไม่ได้แนบไฟล์
      </v-btn>

      <!-- แนบไฟล์แล้ว -->
      <v-btn
        v-else
        small
        outlined
        color="info"
        class="license-btn"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-magnify</v-icon>
        {{ item.pt_licence }}
      </v-btn>

      <!-- วันหมดอายุ -->
      <div class="expiry-date" v-if="item.pt_enddate">
        <v-icon x-small class="mr-1">mdi-calendar-clock</v-icon>
        หมดอายุ
        {{ item.pt_enddate | moment("add", "543 year") | moment("D MMMM YYYY") }}
      </div>
    </template>

    <!-- ===== กรณีมี P License (ใบอนุญาตปฏิบัติหน้าที่ครู) ===== -->
    <template v-else-if="item.mt_license_status === 'donot'">
      <!-- ไม่ได้แนบไฟล์ -->
      <v-btn
        v-if="!hasLicenceFileTem"
        small
        outlined
        color="error"
        class="license-btn"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-alert</v-icon>
        ไม่ได้แนบไฟล์
      </v-btn>

      <!-- แนบไฟล์แล้ว -->
      <v-btn
        v-else
        small
        outlined
        color="info"
        class="license-btn"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-magnify</v-icon>
        {{ item.pt_ondate_tem }}
      </v-btn>

      <!-- วันหมดอายุ -->
      <div class="expiry-date" v-if="item.pt_enddate_tem">
        <v-icon x-small class="mr-1">mdi-calendar-clock</v-icon>
        หมดอายุ
        {{ item.pt_enddate_tem | moment("add", "543 year") | moment("D MMMM YYYY") }}
      </div>
    </template>

    <!-- ===== กรณีอยู่ระหว่างยื่นคำขอ P License ===== -->
    <template v-else-if="item.mt_license_status === 'waitpl'">
      <!-- ไม่ได้แนบไฟล์ -->
      <v-chip
        v-if="!hasLicenceFileTem"
        small
        color="warning"
        class="license-chip"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-clock-outline</v-icon>
        อยู่ระหว่างยื่นคำขอ (P License)
      </v-chip>

      <!-- แนบไฟล์แล้ว -->
      <v-btn
        v-else
        small
        outlined
        color="info"
        class="license-btn"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-magnify</v-icon>
        {{ item.pt_ondate_tem }}
      </v-btn>
    </template>

    <!-- ===== กรณีไม่มีข้อมูลหรือกรอกไม่ถูกต้อง ===== -->
    <template v-else>
      <v-btn
        small
        rounded
        outlined
        color="warning"
        class="license-btn"
        @click="onClickDetail"
      >
        <v-icon left small>mdi-alert</v-icon>
        ไม่มี / กรอกข้อมูลไม่ถูกต้อง
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  name: "LicenseStatus",

  props: {
    /**
     * ข้อมูลครูผู้ช่วยแต่ละแถว (item จาก v-data-table)
     * ต้องมี field: mt_license_status, pt_licence, pt_licence_file,
     *   pt_licence_file_ipa, pt_licence_file_ipacomment,
     *   pt_licence_file_tem, pt_ondate_tem, pt_enddate, pt_enddate_tem, mt_id
     */
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** ตรวจว่ามีไฟล์ใบประกอบวิชาชีพหรือไม่ */
    hasLicenceFile() {
      return String(this.item.pt_licence_file || "").length >= 10;
    },

    /** ตรวจว่ามีไฟล์ P License หรือไม่ */
    hasLicenceFileTem() {
      return String(this.item.pt_licence_file_tem || "").length >= 10;
    }
  },

  methods: {
    onClickDetail() {
      this.$emit("click-detail", this.item.mt_id);
    }
  }
};
</script>

<style scoped>
.license-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

/* ===== สถานะ IPA ===== */
.ipa-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
}

.ipa-pass {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.ipa-fail {
  background-color: #ffebee;
  color: #c62828;
}

/* ===== ปุ่มและ chip ===== */
.license-btn {
  text-transform: none !important;
  font-size: 12px !important;
  letter-spacing: 0 !important;
  max-width: 200px;
}

.license-chip {
  cursor: pointer;
  font-size: 12px !important;
}

/* ===== วันหมดอายุ ===== */
.expiry-date {
  font-size: 11px;
  color: #757575;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* ===== Responsive ===== */
@media (max-width: 960px) {
  .license-btn {
    font-size: 11px !important;
  }

  .license-chip {
    font-size: 11px !important;
  }

  .ipa-badge {
    font-size: 10px;
  }
}
</style>